// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=\"checkbox\"] + label[data-v-1c8ee5a7] {\n  margin-left: 0;\n}\n.tbl_col td[data-v-1c8ee5a7] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
